import { useConfig } from '../api'
import { dictionary } from 'data'

export type TranslateKey = null | string | TemplateStringsArray
export type TranslateFunction = (key: TranslateKey) => string

export const useTranslate = () => {
    const { data: config, isLoading } = useConfig()
    return isLoading ? {
        __: () => '',
        isLoading: true,
        isError: false
    } : !config ? {
        __: () => '',
        isLoading: false,
        isError: true
    } : {
        __: (key: TranslateKey, replacements?: any) => {
            const local = config.locale as keyof typeof dictionary
            const localDictionary = dictionary[local]
            const dictionaryKey = key as keyof typeof localDictionary
            return replaceVariables(localDictionary[dictionaryKey], replacements)
        },
        isLoading: false,
        isError: false
    }
}

const replaceVariables = (str: string, args: any) => {
    for(const key in args){
        const value = String(args[key])
        str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), value)
    }
    return str
}
